"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
/**
 * LocaleManager entry point.
 */
class LocaleManager extends react_1.default.Component {
    render() {
        const childProps = {};
        for (const p in this.props) {
            if (p && typeof p === 'string') {
                childProps[p] = this.props[p];
            }
        }
        const children = react_1.default.Children.map(this.props.children, child => {
            return react_1.default.cloneElement(child, childProps);
        });
        return react_1.default.createElement("div", null, children);
    }
}
LocaleManager.propTypes = {
    children: prop_types_1.default.node
};
exports.default = LocaleManager;
//# sourceMappingURL=LocaleManager.js.map